import { FC } from 'react';
import { useOpenSearchContext } from 'opensearch/hooks';
import { Container, FiltersTreez } from '@/components';
import styles from './CollectionTreezHeading.module.scss';

const CollectionTreezHeading: FC = () => {
  const {
    searchFilter,
    totalHits: totalHitsRaw,
    hits,
    pageSize,
    from,
  } = useOpenSearchContext();

  // Normalizations
  const totalHits = totalHitsRaw ?? 0;
  const search = searchFilter?.trim() ?? '';
  const hasSearch = search.length > 0;

  const perPage = pageSize ?? 0;
  const numHits = hits?.length ?? 0;

  // Range shown (1–20, 21–40, etc.)
  // start: based on 'from'
  // end: the minimum between (from + pageSize), totalHits and what actually came in 'hits'
  const start = totalHits === 0 ? 0 : Math.min(from ?? 0, totalHits - 1) + 1;
  const computedEndByPage = (from ?? 0) + (perPage || numHits || 0);
  const end = Math.min(computedEndByPage, (from ?? 0) + numHits, totalHits);

  const pluralize = (count: number) => (count === 1 ? 'result' : 'results');

  const resultsLabel = `${start}-${end} of ${totalHits} ${pluralize(
    totalHits,
  )}`;

  const content = hasSearch ? (
    <>
      Showing {resultsLabel} for{' '}
      <span>
        &quot;<mark>{search}</mark>&quot;
      </span>
    </>
  ) : (
    <>Showing {resultsLabel}</>
  );

  return (
    <div className={styles.collection_heading_info_container}>
      {totalHits > 0 && (
        <Container
          aria-atomic="true"
          aria-live="polite"
          className={styles.collection_heading_info}
          role="status"
        >
          <h2 tabIndex={-1}>{content}</h2>
        </Container>
      )}
      <FiltersTreez />
    </div>
  );
};

export default CollectionTreezHeading;
